// NOTE: This has to be called authState, since the 'auth'
// library expects the feature store to be called that.
export const FEATURE_KEY = 'authState';
